/*
 * AD custom JavaScript entrypoint.
 *
 * Keep project-specific storefront logic in ad-* assets instead of editing
 * vendor.js/theme.js unless absolutely required.
 */

document.addEventListener('cart:updated', () => {
  // Reserved hook for AD custom cart behaviors.
});

